export const searchTypes = Object.freeze({
  patient: 1,
  drug: 0,
});
